const config = {
    basename: '',
    defaultPath: '/dashboard',
    fontFamily: `'Poppins', sans-serif`,
    borderRadius: 12
};

export default config;
